<p-wrapper
  id="page-success"
  titleWrapper=" Opération réalisée avec succès !"
  [withHomeButton]="true"
>
  <div body>
    <div class="text-center">
      <img
        src="assets/images/success.png"
        class="image-success mb-2"
        alt="succès"
      />
      <p>{{ message }}</p>
    </div>
  </div>
</p-wrapper>
